import React, {Component, PropTypes} from 'react'
import cx from 'classnames'

export class RadioTab extends Component {
  static propTypes = {
    value: PropTypes.any,
    activeValue: PropTypes.any,
    onClick: PropTypes.func,
    children: PropTypes.node,
    className: PropTypes.string,
  }

  onClick = () => {
    const {value, onClick} = this.props
    onClick(value)
  }

  render() {
    const {value, activeValue, children, className} = this.props

    return (
      <button 
        className={cx("radio-tab", className, {'active': value === activeValue})}
        onClick={this.onClick}
      >
        {children}
      </button>
    )
  }
}

class RadioTabs extends Component {
  static propTypes = {
    value: PropTypes.any,
    onChange: PropTypes.func,
    children: PropTypes.arrayOf(PropTypes.element),
  }

  onChange = (value) => {
    const {onChange} = this.props
    onChange(value)
  }

  render() {
    const {value, onChange, children} = this.props

    return (
      <div className="radio-tabs">
        {children.map(tab =>
          React.cloneElement(tab, {
            key: tab.props.value,
            activeValue: value,
            onClick: onChange,
          })
        )}
      </div>
    )
  }
}

export default RadioTabs